import { render } from "./Top.vue?vue&type=template&id=2ab36bb2&scoped=true"
const script = {}

import "./Top.vue?vue&type=style&index=0&id=2ab36bb2&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab36bb2"]])

export default __exports__